export enum SlaTypeEnum {
  STATIC = 'static',
  VARIABLE = 'variable',
}

export enum EscalationTypeEnum {
  STATIC = 'static',
  VARIABLE = 'variable',
}
